import { FC, FormEvent, useCallback, useEffect, useMemo, useState } from 'react';

import SearchIcon from '../IconsSvg/SearchIcon';

import { getRequestedLanguages } from '../../locale/languages';

interface Props {
    query: string | null;
    onSearchSubmit: React.Dispatch<React.SetStateAction<string | null>>;
}

export const SearchBar: FC<Props> = ({ query, onSearchSubmit }) => {
    const language = getRequestedLanguages(window.berardi_accountUserData.language);
    const [searchQuery, setSearchQuery] = useState(query ?? '');

    const handleSubmit = useCallback(
        (event: FormEvent) => {
            event.preventDefault();
            onSearchSubmit(searchQuery);
        },
        [searchQuery],
    );

    useEffect(() => {
        if (query && searchQuery != query) {
            setSearchQuery(query);
        }
    }, [query]);

    return (
        <>
            <form onSubmit={handleSubmit} className="search search-modal__form">
                <div className="field">
                    <input
                        className="search__input field__input"
                        id="custom-search"
                        type="text"
                        name="q"
                        value={searchQuery}
                        placeholder={language.search.search_code}
                        onChange={(event) => setSearchQuery(event.target.value)}
                    />
                    <label className="field__label" htmlFor="custom-search">
                        {language.search.search_code}
                    </label>
                    <button className="search__button field__button" aria-label={language.search.search_code}>
                        <SearchIcon />
                    </button>
                </div>
            </form>
        </>
    );
};
